var map = {
	"./iconmonstr-blog-4.svg": "hxju",
	"./iconmonstr-linkedin-4.svg": "aUBE",
	"./iconmonstr-medium-4.svg": "j/0Q",
	"./iconmonstr-reddit-4.svg": "F/Cp",
	"./iconmonstr-twitter-4.svg": "58xb",
	"./iconmonstr-youtube-4.svg": "HJq1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XQAt";